import angular from 'angular';
import insurancesSaveToContact from './insurancesSaveToContact';

export default angular
  .module('components.insurancesSaveToContact', [])
  .component('insurancesSaveToContact', insurancesSaveToContact).name;
